export const setStartEndDateBp = (scheduleOfPrograms, programId, scheduleId) => {

    // looping bp
    for (let i = 0; i < scheduleOfPrograms.length; i++) {
        // looping bpi
        for (let x = 0; x < scheduleOfPrograms[i].BundlingProgramItems.length; x++) {
            // get ProgramId
            if (scheduleOfPrograms[i].BundlingProgramItems[x].Program.id === programId) {
                // looping schedule selected
                for (let y = 0; y < scheduleOfPrograms[i].BundlingProgramItems[x].Program.Schedules.length; y++) {
                    if (scheduleOfPrograms[i].BundlingProgramItems[x].Program.Schedules[y].id == scheduleId) {
                        return {
                            startDate: scheduleOfPrograms[i].BundlingProgramItems[x].Program.Schedules[y].startDate,
                            endDate: scheduleOfPrograms[i].BundlingProgramItems[x].Program.Schedules[y].endDate
                        }
                    }
                }
            }
        }
    }
}